var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyKarmaPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E2FFEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#41CD70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.938 19.95L13.9363 19.95C13.7476 19.9492 13.5665 19.8744 13.4327 19.7414C13.4327 19.7413 13.4326 19.7413 13.4325 19.7412L10.9833 17.3174L10.9778 17.3119L10.9728 17.3061C10.8552 17.1703 10.7935 16.9952 10.8005 16.8158C10.8075 16.6364 10.8827 16.4666 11.0104 16.3402L13.938 19.95ZM13.938 19.95C14.1267 19.9492 14.3079 19.8744 14.4416 19.7414C14.4417 19.7413 14.4418 19.7413 14.4419 19.7412L21.0167 13.2345L21.0222 13.229L21.0272 13.2232C21.1448 13.0874 21.2065 12.9123 21.1995 12.7329C21.1925 12.5535 21.1173 12.3837 20.9896 12.2573C20.862 12.131 20.6913 12.0574 20.5118 12.0505C20.3323 12.0437 20.1565 12.1041 20.0195 12.2201L20.0137 12.2251M13.938 19.95L20.0137 12.2251M20.0137 12.2251L20.0082 12.2305M20.0137 12.2251L20.0082 12.2305M20.0082 12.2305L13.9371 18.2362L20.0082 12.2305Z",
    fill: "#41CD70",
    stroke: "#41CD70",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyKarmaPoints);
export default __webpack_public_path__ + "static/media/daily-karma-points.4ca46c224d6ecb9dc284bf32dba6d63e.svg";
export { ForwardRef as ReactComponent };